import { ChevronLeft, ChevronRight } from "lucide-react";

export const PAGE_SIZE = 25;

export function paginate(list, page, size = PAGE_SIZE) {
  const start = (page - 1) * size;
  return (list || []).slice(start, start + size);
}

export function Pager({ page, pageSize = PAGE_SIZE, total, onPage }) {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if ((total || 0) <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  const btn = "h-7 px-2 rounded-md border border-[#DAD5CA] text-[#59554D] hover:bg-[#F4F2ED] disabled:opacity-40 disabled:hover:bg-transparent flex items-center gap-1 text-[12px]";
  return (
    <div className="flex items-center justify-between px-4 py-2.5 border-t border-[#E6E2D9] bg-[#FBFAF7]" data-testid="pager">
      <span className="text-[12px] text-[#59554D]">Showing <span className="font-medium text-[#1A1A1A]">{from}–{to}</span> of <span className="font-medium text-[#1A1A1A]">{total}</span></span>
      <div className="flex items-center gap-2">
        <button className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="pager-prev"><ChevronLeft className="w-3.5 h-3.5" /> Prev</button>
        <span className="text-[12px] text-[#59554D]">Page {page} / {pages}</span>
        <button className={btn} disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="pager-next">Next <ChevronRight className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}
